// extracted by mini-css-extract-plugin
module.exports = {"contentPage":"ContentPageTemplate-module--contentPage--1MhQc","runningText":"ContentPageTemplate-module--runningText--3ono6"};